import { render, staticRenderFns } from "./CheckoutStep.vue?vue&type=template&id=56d37a16&"
import script from "./CheckoutStep.vue?vue&type=script&lang=js&"
export * from "./CheckoutStep.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports